function ServicesSection({ services }) {
  return (
    <section className="pb-16">
      <div className="mb-8 flex items-end justify-between gap-4">
        <h2 className="text-4xl text-brand-text sm:text-5xl">Our core services</h2>
        <a href="/services" className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-primary">
          View all
        </a>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {services.map((service, idx) => (
          <article
            key={service.title}
            className="rounded-3xl border border-brand-petal bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-bloom"
            style={{ animationDelay: `${idx * 120}ms` }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-brand-primary">{service.tag}</p>
            <h3 className="mt-3 text-3xl leading-tight text-brand-text">{service.title}</h3>
            <p className="mt-3 text-sm leading-7 text-brand-text/80">{service.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;